<template>
  <div class="page-top" @click.prevent="scrollToTop">
    <img
      src="@/assets/images/icons/pagetop.svg"
      class="icon"
      alt="ページトップ"
    />
    <span class="text">ページトップへ戻る</span>
  </div>
</template>

<script>
export default {
  name: "BtnPagetop",
  methods: {
    // スクロール量を取得する関数
    getScrolled: function () {
      return window.pageYOffset !== undefined
        ? window.pageYOffset
        : document.documentElement.scrollTop;
    },
    // トップに移動する関数
    scrollToTop: function () {
      const scrolled = this.getScrolled();
      window.scrollTo(0, Math.floor(scrolled / 2));
      if (scrolled > 0) {
        window.setTimeout(this.scrollToTop, 30);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.page-top {
  @include flex(inline-flex, flex-start, center, row, nowrap);
  font-size: 12px;
  cursor: pointer;
  padding: 10px 0;
  @include mq-up(md) {
    font-size: 14px;
  }
  .icon {
    width: 14px;
    height: 14px;
    @include mq-up(md) {
      width: 16px;
      height: 16px;
    }
  }
  .text {
    padding-left: 5px;
    @include mq-up(md) {
      padding-left: 10px;
    }
  }
}
</style>
